import Vue from 'vue'
import Router from 'vue-router'
import AdminLayout from '../layout/AdminLayout.vue'
import Login from '../views/Login.vue'
import ChangePassword from '../views/ChangePassword.vue'
import Dashboard from '../views/Dashboard.vue'
import CategoryList from '../views/category/CategoryList.vue'
import BannerList from '../views/banner/BannerList.vue'
import HomeNavList from '../views/homenav/HomeNavList.vue'
import ProductList from '../views/product/ProductList.vue'
import ProductEdit from '../views/product/ProductEdit.vue'
import OrderList from '../views/order/OrderList.vue'
import OrderDetail from '../views/order/OrderDetail.vue'
import GroupBuyActivityList from '../views/groupbuy/GroupBuyActivityList.vue'
import GroupBuyRecordList from '../views/groupbuy/GroupBuyRecordList.vue'
import RefundRecordList from '../views/groupbuy/RefundRecordList.vue'
import ProfileStyle from '../views/settings/ProfileStyle.vue'
import PickupStoreList from '../views/settings/PickupStoreList.vue'
import StoreConfig from '../views/settings/StoreConfig.vue'
import OrderConfig from '../views/settings/OrderConfig.vue'
import ShareRewardConfig from '../views/share/ShareRewardConfig.vue'
import ShareRewardRecordList from '../views/share/ShareRewardRecordList.vue'
import PointProductList from '../views/pointmall/PointProductList.vue'
import PointProductEdit from '../views/pointmall/PointProductEdit.vue'
import PointOrderList from '../views/pointmall/PointOrderList.vue'
import PointOrderDetail from '../views/pointmall/PointOrderDetail.vue'
import NotFound from '../views/NotFound.vue'
import { getAdminToken, getAdminUser } from '../utils/auth'

Vue.use(Router)

const router = new Router({
  mode: 'hash',
  routes: [
    {
      path: '/login',
      component: Login,
      meta: { public: true }
    },
    {
      path: '/',
      component: AdminLayout,
      redirect: '/dashboard',
      children: [
        { path: 'dashboard', component: Dashboard },
        { path: 'change-password', component: ChangePassword },
        { path: 'categories', component: CategoryList },
        { path: 'banners', component: BannerList },
        { path: 'home-navs', component: HomeNavList },
        { path: 'products', component: ProductList },
        { path: 'products/create', component: ProductEdit },
        { path: 'products/:id', component: ProductEdit, props: true },
        { path: 'orders', component: OrderList },
        { path: 'orders/:orderNo', component: OrderDetail, props: true },
        { path: 'group-buy', component: GroupBuyActivityList },
        { path: 'group-buy/records', component: GroupBuyRecordList },
        { path: 'group-buy/refunds', component: RefundRecordList },
        { path: 'profile-style', component: ProfileStyle },
        { path: 'pickup-stores', component: PickupStoreList },
        { path: 'store-config', component: StoreConfig },
        { path: 'order-config', component: OrderConfig },
        { path: 'share-reward/config', component: ShareRewardConfig },
        { path: 'share-reward/records', component: ShareRewardRecordList },
        { path: 'point-mall/products', component: PointProductList },
        { path: 'point-mall/products/create', component: PointProductEdit },
        { path: 'point-mall/products/:id', component: PointProductEdit, props: true },
        { path: 'point-mall/orders', component: PointOrderList },
        { path: 'point-mall/orders/:orderNo', component: PointOrderDetail, props: true },
        { path: '404', component: NotFound }
      ]
    },
    {
      path: '*',
      redirect: '/404'
    }
  ]
})

router.beforeEach((to, from, next) => {
  const token = getAdminToken()
  const admin = getAdminUser()
  const needChangePassword = Number(admin && admin.needChangePassword) === 1

  if (to.meta.public) {
    if (token) {
      next(needChangePassword ? '/change-password' : '/dashboard')
      return
    }
    next()
    return
  }

  if (!token) {
    next({
      path: '/login',
      query: to.path === '/login' ? {} : { redirect: to.fullPath }
    })
    return
  }

  if (needChangePassword && to.path !== '/change-password') {
    next('/change-password')
    return
  }

  next()
})

export default router
